import React from "react";
import * as S from "./OrganizationCard.styles";

interface OrganizationCardProps {
  name: string;
  description: string;
  logo: string;
  website: string;
}

const OrganizationCard: React.FC<OrganizationCardProps> = ({
  name,
  description,
  logo,
  website,
}) => {
  if(description === null || description === undefined || description === '') {
    description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";
  }
  description = description.slice(0, 100) + '...';
  return (
    <S.OrganizationCardContainer>
      <S.OrganizationLogo src={logo} alt={name} />
      <S.OrganizationInfo>
        <S.OrganizationName>{name}</S.OrganizationName>
        <S.OrganizationDescription>{description}</S.OrganizationDescription>
        {/*<S.LearnMoreLink
          href={website}
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </S.LearnMoreLink>*/}
      </S.OrganizationInfo>
    </S.OrganizationCardContainer>
  );
};

export default OrganizationCard;
